import React, { Component } from 'react';
import Slider from "react-slick";
import slidedata from '../../../data/slidecards';


function NextArrow(props) {
  const {  style, onClick } = props;
  return (
    <div
      className={ "fa fa-angle-right slick-arrow custom-slider-next"}
      style={{ ...style, display: "block", background: "black" }}
      onClick={onClick}
    />
  );
}

function PrevArrow(props) {
  const {  style, onClick } = props;

  return (
    <div
      className={ "fa fa-angle-left slick-arrow custom-slider-prev"}
      style={{ ...style, display: "block", background: "black" }}
      onClick={onClick}
    />
  );
}


class TheChangeSlider extends Component {

  render() {
    var settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            initialSlide: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    };
    return (
      <Slider {...settings}>
        {
          slidedata.map(function(slide){
            if (slide.linktile < 0)
            return (
              <div key={slide} className="card">
                <div className="card-image">
                  <img src={slide.image} alt="image1" />
                </div>
                <div className="card-copy">
                  <h5>{slide.title}</h5>
                  <p>{slide.copy}</p>
                </div>
              </div>
            );
            return (
              <div key={slide} className="card">
                <div className="card-image">
                  <img src={slide.image} alt="image1" />
                </div>
                <div className="card-copy">
                  <h5>{slide.title}</h5>
                  <p>{slide.copy}</p>
                  <a href={slide.link} target="_blank">{slide.linktitle}</a>
                </div>
              </div>
            );
          })
        }
      </Slider>
    );
  }
}

export default TheChangeSlider;



// WEBPACK FOOTER //
// ./src/components/TheChange/TheChangeSlider/TheChangeSlider.js